import Spinner from '@web-ui-kit/loader'
import * as Sc from './Loader.style'

const Loader = () => (
  <Sc.WrapperLoader>
    <Spinner variant='circle' />
  </Sc.WrapperLoader>
)

export default Loader
